import { render } from "./ProspectReviewsSummary.vue?vue&type=template&id=6a085f72"
import script from "./ProspectReviewsSummary.vue?vue&type=script&lang=js"
export * from "./ProspectReviewsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__